// src/components/DispatchModules.jsx
import { Stack } from "@chakra-ui/react";
import Card from "./Card";
import DispatchReadySectors from "./DispatchReadySectors";
import PrintScheduler from "./PrintScheduler";
import DispatchHistory from "./DispatchHistory";
import SlotUnlockVisualizer from "./SlotUnlockVisualizer";

/**
 * DispatchModules
 *
 * Props:
 *  - businessId (uuid, businesses.business_uuid)  🔥 dispatch tables use UUID
 *  - flyerId (uuid)
 *  - region (string)
 *  - group (string/uuid)
 *  - slotCount (number)
 */
export default function DispatchModules({
  businessId,
  flyerId,
  region,
  group,
  slotCount,
  unlockThreshold = 15,
}) {
  return (
    <Stack spacing={6} mt={8}>
      <Card>
        <h2 style={{ fontSize: "1rem", fontWeight: 600, marginBottom: "8px" }}>
          Unlocked Slots
        </h2>
        <SlotUnlockVisualizer
          slotCount={slotCount}
          unlockThreshold={unlockThreshold}
          flyerId={flyerId}
        />
      </Card>

      <Card>
        <h2 style={{ fontSize: "1rem", fontWeight: 600, marginBottom: "8px" }}>
          Dispatch-Ready Sectors
        </h2>
        <DispatchReadySectors
          businessId={businessId}   // ✔ correct: dispatch_queue uses business_uuid
          campaignId={flyerId}
          region={region}
          group={group}
        />
      </Card>

      <Card>
        <h2 style={{ fontSize: "1rem", fontWeight: 600, marginBottom: "8px" }}>
          Print Scheduler
        </h2>
        <PrintScheduler
          businessId={businessId}   // ✔ correct
          campaignId={flyerId}
          region={region}
          group={group}
        />
      </Card>

      <Card>
        <h2 style={{ fontSize: "1rem", fontWeight: 600, marginBottom: "8px" }}>
          Dispatch History
        </h2>
        <DispatchHistory
          businessId={businessId}   // ✔ correct
          campaignId={flyerId}
          region={region}
          group={group}
        />
      </Card>
    </Stack>
  );
}
